import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Flex,
  Image,
  Text,
} from "@chakra-ui/react";
import { TokenPill } from "../stake/TokenPill";
import { DRIP_BOX_BG } from "./dripStyles";

export interface DripInputAssetOption {
  symbol: string;
  image: string;
}

interface DripInputTokenPickerProps {
  options: readonly DripInputAssetOption[];
  selectedAsset: string;
  selectedAssetImage: string;
  onSelect: (asset: string, image: string) => void;
}

export const DripInputTokenPicker = ({
  options,
  selectedAsset,
  selectedAssetImage,
  onSelect,
}: DripInputTokenPickerProps) => (
  <Menu placement="bottom-start">
    <MenuButton as={Button} type="button" variant="unstyled" minW={0} h="auto" p={0}>
      <TokenPill image={selectedAssetImage} symbol={selectedAsset} showChevron />
    </MenuButton>
    <Portal>
      <MenuList bg={DRIP_BOX_BG} borderColor="whiteAlpha.200" minW="180px">
        {options.map(({ symbol, image }) => (
          <MenuItem
            key={symbol}
            bg={DRIP_BOX_BG}
            _hover={{ bg: "whiteAlpha.100" }}
            onClick={() => onSelect(symbol, image)}
          >
            <Flex alignItems="center" gap={2}>
              <Image src={image} boxSize="20px" borderRadius="full" />
              <Text color="white" fontSize="sm">
                {symbol}
              </Text>
            </Flex>
          </MenuItem>
        ))}
      </MenuList>
    </Portal>
  </Menu>
);
